import { Button } from '@app/shared';
import { ButtonTypeProps } from '@sharedUi/ui-kit/Button/TypeProps';
import { ButtonThemes } from '@sharedUi/ui-kit/Button';
import IconClose from './icons/close.svg';

import styles from './ButtonClose.module.scss';

export const ButtonClose = (props: ButtonTypeProps) => {
  return (
    <Button className={styles.Btn} themes={ButtonThemes.Clear} {...props}>
      <IconClose width={20} height={20} />
    </Button>
  );
};
